import { kramerMediaArray } from './kramerMedia'
import { kramerBio } from './kramerBios'

import { georgeReviewerReviewHinge, jerryReviewerReviewBumble, elaineReviewerReviewTinder } from './kramerReviewerReviews'
import { georgeReviewerProfile, jerryReviewerProfile, elaineReviewerProfile } from './kramerReviewers'

export const georgeProfileReviewHinge = {
  _id: 'georgeProfileReviewHingeId',
  userId: 'kramerUserId',
  userEmail: 'kramer@email.com',
  datingProfileId: 'kramerDatingProfileHingeId',
  reviewerProfileId: 'georgeReviewerProfileId',
  reviewerEmail: 'george@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Looking distinguished. It might turn off anti-smokers though`,
      verdict: 'Yes',
    },
    {
      feedback: `This is... disgusting`,
      verdict: 'No',
    },
    {
      feedback: `Love it. Not only is he handsome but he smells good too`,
      verdict: 'Yes',
    },
    {
      feedback: `Not sure who hitting golf balls into the ocean is going to impress`,
      verdict: 'No',
    },
    {
      feedback: `Like the candid friend pic. Social proof for sure`,
      verdict: 'Yes',
    },
    {
      feedback: `Will definitely turn off anti-smokers but you have a fun vibe here`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens someone Googles Kramerica Industries?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `Who does this impress?`,
        verdict: 'No', 
      },
      {
        feedback: `Funny, except the pictures show you're serious`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Kramer is a total wildcard. Though he might be entertaining, it's unclear how tethered he is to social conventions`,
    good: `The first photo and the beach pic are good. I also like the friend pic, and the last pic is decent as well`,
    notGood: `The shower pic, all whacking golf balls into the ocean references, and all prompt responses`,
    verdict: `Kramer is nowhere close to presenting an attractive self, though, yes, this probably is his most *authentic* self... You're gonna have to hide yourself better to get quality matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...georgeReviewerReviewHinge },
  reviewerProfile: { ...georgeReviewerProfile },
  bioItems: { ...kramerBio },
  mediaItems: [ ...kramerMediaArray ],
}

export const jerryProfileReviewBumble = {
  _id: 'jerryProfileReviewBumbleId',
  userId: 'kramerUserId',
  userEmail: 'kramer@email.com',
  datingProfileId: 'kramerDatingProfileBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  reviewerEmail: 'jerry@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Looking distinguished. It might turn off anti-smokers though`,
      verdict: 'Yes',
    },
    {
      feedback: `This is... disgusting`,
      verdict: 'No',
    },
    {
      feedback: `Love it. Not only is he handsome but he smells good too`,
      verdict: 'Yes',
    },
    {
      feedback: `Not sure who hitting golf balls into the ocean is going to impress`,
      verdict: 'No',
    },
    {
      feedback: `Like the candid friend pic. Social proof for sure`,
      verdict: 'Yes',
    },
    {
      feedback: `Will definitely turn off anti-smokers but you have a fun vibe here`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: kramerBio.aboutMe[0],
    hobbies: [kramerBio.hobbies[0], kramerBio.hobbies[1], kramerBio.hobbies[2], kramerBio.hobbies[3], kramerBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens someone Googles Kramerica Industries?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `Who does this impress?`,
        verdict: 'No', 
      },
      {
        feedback: `Funny, except the pictures show you're serious`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Kramer is a total wildcard. Though he might be entertaining, it's unclear how tethered he is to social conventions`,
    good: `The first photo and the beach pic are good. I also like the friend pic, and the last pic is decent as well`,
    notGood: `The shower pic, all whacking golf balls into the ocean references, and all prompt responses`,
    verdict: `Kramer is nowhere close to presenting an attractive self, though, yes, this probably is his most *authentic* self... You're gonna have to hide yourself better to get quality matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...jerryReviewerReviewBumble },
  reviewerProfile: { ...jerryReviewerProfile },
  bioItems: { ...kramerBio },
  mediaItems: [ ...kramerMediaArray ],
}

export const elaineProfileReviewTinder = {
  _id: 'elaineProfileReviewTinderId',
  userId: 'kramerUserId',
  userEmail: 'kramer@email.com',
  datingProfileId: 'kramerDatingProfileTinderId',
  reviewerProfileId: 'elaineReviewerProfileId',
  reviewerEmail: 'elaine@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Looking distinguished. It might turn off anti-smokers though`,
      verdict: 'Yes',
    },
    {
      feedback: `This is... disgusting`,
      verdict: 'No',
    },
    {
      feedback: `Love it. Not only is he handsome but he smells good too`,
      verdict: 'Yes',
    },
    {
      feedback: `Not sure who hitting golf balls into the ocean is going to impress`,
      verdict: 'No',
    },
    {
      feedback: `Like the candid friend pic. Social proof for sure`,
      verdict: 'Yes',
    },
    {
      feedback: `Will definitely turn off anti-smokers but you have a fun vibe here`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: kramerBio.aboutMe[0],
    hobbies: [kramerBio.hobbies[0], kramerBio.hobbies[1], kramerBio.hobbies[2], kramerBio.hobbies[3], kramerBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `What happens someone Googles Kramerica Industries?`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `If this is a joke nobody will get it`,
        verdict: 'No', 
      },
      {
        feedback: `Who does this impress?`,
        verdict: 'No', 
      },
      {
        feedback: `Funny, except the pictures show you're serious`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Kramer is a total wildcard. Though he might be entertaining, it's unclear how tethered he is to social conventions`,
    good: `The first photo and the beach pic are good. I also like the friend pic, and the last pic is decent as well`,
    notGood: `The shower pic, all whacking golf balls into the ocean references, and all prompt responses`,
    verdict: `Kramer is nowhere close to presenting an attractive self, though, yes, this probably is his most *authentic* self... You're gonna have to hide yourself better to get quality matches`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...elaineReviewerReviewTinder },
  reviewerProfile: { ...elaineReviewerProfile },
  bioItems: { ...kramerBio },
  mediaItems: [ ...kramerMediaArray ],
}